import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService, NbSearchService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { EnvService } from 'src/app/env.service';
import { liveSearch } from '../dash.operator';
import { DashService } from '../dash.service';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import consoleCommands from '../../../../backend/resources/consoleCommands.js';
import { getProvisionFormatError } from '../../../../backend/resources/provisionJsonFormat.js';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import * as moment from 'moment';
import { read, utils, writeFile } from 'xlsx';
import Axios from 'axios';
import { chunkSubstr } from 'src/app/utils/utils';
import { PasswordDialogComponent } from 'src/app/password-dialog/password-dialog.component';

@Component({
  selector: 'app-utils',
  templateUrl: './utils.component.html',
  styleUrls: ['./utils.component.css']
})
export class UtilsComponent implements OnInit {

  extractNodeTypeLoading = false;
  extractCustomerDataLoading = false;
  deBlackListingLoading = false;
  hubVariantChangeLoading=false;
  loadingAccessInternal = true;
  loadingAccessDeveloper = true;
  loadingAccessRequest = true;
  loadingAccessRequestAsked = true;
  loadingAccessRequestTaken=true;
  loadingAccessRequestInternalTransfer=true;
  loadingAccessRequestDeveloperTransfer=true;
  loadingAccessRequestAudit = false;
  comDecomHistoryLoading = false;
  lockedAccountsLoading=false;
  serviceTestingLoading = false;
  kitInfoLoading = false;
  unlockKitLoading = false;
  batchNodeOTALoading = false;
  consolePinLoading = true;
  sceneDetailsLoading = false;
  
  serviceTestingComment = "";
  serviceTestingEid = "";
  hubVariantEid="";
  serviceTestingEidAdding = "";
  consolePinToday = "";
  impPasswd = "";
  impPasswdAllowed = false;
  impPasswdLoading = false;
  impPasswdDialogOpen = false;
  impPasswdLoaded = false;
  batchNodeOTAEid = "";
  extractCustomerContact = "";
  extractNodeTypes = "";
  deblacklistEid= "";
  deblacklistReason= "";
  unlockKitHubId= "";
  unlockKitReason= "";
  unlockKitApprover = "";
  extractNodeTypeReason = "";
  extractCustomerDataReason = "";
  kitHubId = "";
  sceneHubId = "";
  sceneName = "";
  comDecomEid = "";
  hubId = ""
  auditPlaceId="";
  nodeIds = {}
  oldEid = "";
  newEid = "";
  reason = "";
  customer = {contact:"",_id:""};
  selectedFeature = "Provision"
  showSceneDetailsNewBanner = new Date().getTime() <= new Date(2026, 8, 30, 23, 59, 59, 999).getTime();
  features = [
    "Provision",
    "Change First Com Date",
    "Extended Warranty",
    "Com Decom History",
    "Locked Accounts",
    // "Service Testing",
    "Kit Info",
    "Scene Details",
    "Warranty",
    "De-Blacklist",
    "Hub Variant",
    "Unlock Kit",
    "Batch Node OTA",
    "Extract Node Type Data",
    "Extract Customer Data",
    // "Change HUB Place",
    "Refresh OTA Buckets",
    "Health Data",
    "Packet Analyzer"
  ]
  showSearchCard = false;
  searchValue = " ";
  data = [];
  dataAsked = [];
  dataTaken = []
  dataAudit = []
  batchNodeOTAEids=[];
  dataSupportGuys = [];
  selectedSupportGuy = undefined;
  dataDevelopers = [];
  selectedDeveloper = undefined;
  warrantyEid = ""
  warrantyLoading = false;
  provisionLoading = false;
  showCopyProvisionData = false;
  copyProvisionLoading = false;
  copyProvisionFileReading = false;
  copyProvisionFileName = '';
  copyProvisionDragging = false;
  private copyProvisionFileReadId = 0;
  copyProvisionError = '';
  copyProvisionMessage = '';
  copyProvisionDocument: any = undefined;
  copyProvisionTokens: { text: string; color: string }[] = [];
  loadingReplacement=false;
  firstComDateChangeLoading = false;
  batchNodeOTARequestsLoading = false;
  warrantyMessage = "";
  provisionEid="";
  nrHistoryEid="";
  isWarrantyGood = 0;
  deductWarranty=false;
  isSupport = false;
  isDeveloper = false;
  healthEid = "";
  showAllData = false;
  graphStart = undefined;
  graphEnd = undefined;
  healthEidOld = "";
  firstComDateChangeEid = "";
  extWarrantyDateChangeHub=undefined;
  extWarrantyDateChangeEidHub = "";
  firstComDateChangeHub = "";
  firstComDateChangeContact = "";
  firstComDateChangeDate = undefined;
  firstComDateChangeDateHub = undefined;
  firstComDateChangeTime = undefined;
  firstComDateChangeTimeHub = undefined;
  graph = {}
  loadingHealthData = false;
  auditDate = new Date();
  provisionData = undefined;
  provisionDataDownload = undefined;
  localDataReplacement;
  dataSourceForReplacement=[];
  comDecomData = [];
  kitData = [];
  sceneData = undefined;
  sceneEdgeDataRows = [];
  appActionTypes = ["ACTION", "SETTING", "IR", "DELAY", "IR2", "UNKNOWN", "VIRTUAL"];
  serviceTestingData = [];
  lockedAccounts = [];
  batchNodeOTARequests = [];


  displayedColumnsForReplacement: string[] = ['oldEid', 'newEid',"invokerId","reason","customerEmail","initiationDate","completionDate"];
  domLayout = 'autoHeight';
  public columnDefs: ColDef[] = [
    { field: 'date',resizable:true},
    { field: 'placeName',headerName:"Place Name",resizable:true},
    { field: 'ticketId',headerName:"Zoho Ticket ID",resizable:true},
    { field: 'customerId',headerName:"Targeted Customer",resizable:true},
    { field: 'invokedBy',headerName:"Done By" ,resizable:true},
    {field:'type',headerName:'Action',wrapText: true,autoHeight: true,resizable:true},
    {field:'additionalData',headerName:'Additional Data',wrapText: true,autoHeight: true,resizable:true}
  ];

  public columnDefsProvision: ColDef[] = [
    { field: 'eid',headerName:"eID",resizable:true},
    { field: 'type',headerName:"Type",resizable:true},
    { field: 'fwVPlain',headerName:"Firmware Version",resizable:true},
    { field: 'owner',headerName:"Current Owner",resizable:true},
    { field: 'region',headerName:"Region",resizable:true},
    { field: 'fAt',headerName:"Provisioned At",resizable:true},
    { field: 'comDecomHistory',headerName:"Com/Decom History",resizable:true,autoHeight:true,wrapText:true},
  ];

  public columnDefsComDecomHistory: ColDef[] = [
    { field: 'eId',headerName:"eID",resizable:true},
    { field: 'type',headerName:"Type",resizable:true},
    { field: 'parentId',headerName:"Parent ID (HUB)",resizable:true},
    { field: 'contactInfo',headerName:"Contact Info",resizable:true},
    { field: 'date',headerName:"Date",resizable:true},
  ];

  public columnDefsServiceTestingData: ColDef[] = [
    { field: 'eid',headerName:"eID",resizable:true},
    { field: 'markedBy',headerName:"Marked By",resizable:true},
    { field: 'markedAt',headerName:"Marked At",resizable:true},
    { field: 'comment',headerName:"Comment",resizable:true,wrapText: true,autoHeight: true,initialWidth:400},
  ];

  public columnDefsLockedAccounts:ColDef[] = [
    { field: 'customerInfomation',headerName:"Customer Information",resizable:true},
    { field: 'hubId',headerName:"Hub ID",resizable:true},
    {field:"blockFunctionality",headerName:"Block Functionality",resizable:true},
    { field: 'reason',headerName:"Reason",resizable:true,wrapText: true,autoHeight: true,initialWidth:300},
    { field: 'requiredAction',headerName:"Required Action",resizable:true,wrapText: true,autoHeight: true,initialWidth:300},
    {field:"modifiedBy",headerName:"Modified By",resizable:true},
    {field:"updatedAt",headerName:"Modification Time",resizable:true},
  ]

  public columnDefsKitInfo: ColDef[] = [
    { field: 'nodeId',headerName:"eID",resizable:true},
    { field: 'type',headerName:"Type",resizable:true},
    { field: 'date',headerName:"Configured At",resizable:true},
    { field: 'configId',headerName:"Kit Type",resizable:true},
  ];

  public defaultColDefBatchNodeOTARequests: ColDef[] = [
    { field: 'nodeEid',headerName:"Node eID",resizable:true},
    { field: 'hubId',headerName:"HUB ID",resizable:true},
    { field: 'status',headerName:"Status",resizable:true},
    { field: 'attemptNo',headerName:"Total Attempts",resizable:true},
    { field: 'message',headerName:"Message",resizable:true},
    { field: 'requestedBy',headerName:"Requested By",resizable:true},
    { field: 'requestedAt',headerName:"Requested At",resizable:true},
    { field: 'lastUpdatedAt',headerName:"Last Updated At",resizable:true},
  ];

  
 
  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
  };

  constructor(public userDetails: UserDetailComponent, private route: ActivatedRoute, private http: HttpClient, private router: Router, public dashService: DashService, private env: EnvService,private dialogService:NbDialogService) { }

  ngOnInit(): void {
    this.graphStart = moment().subtract(1,"month").toDate();
    this.graphEnd = moment().toDate();
    this.reloadEverything();
    this.http.get(this.env.apiUrl + '/api/hubTransfer/copyProvisionData/availability').subscribe(response => {
      this.showCopyProvisionData = response['enabled'] === true;
    }, () => {
      this.showCopyProvisionData = false;
    });
  }

  onCopyProvisionFileChange(event: Event) {
    if (this.copyProvisionLoading) return;
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    // The filename is displayed separately; clearing the native control also
    // lets users select the same file again after an error or successful copy.
    input.value = '';
    this.loadCopyProvisionFile(file);
  }

  onCopyProvisionDragOver(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = this.copyProvisionLoading ? 'none' : 'copy';
    this.copyProvisionDragging = !this.copyProvisionLoading;
  }

  onCopyProvisionDragLeave(event: DragEvent) {
    if (event.relatedTarget && (event.currentTarget as HTMLElement).contains(event.relatedTarget as Node)) return;
    this.copyProvisionDragging = false;
  }

  onCopyProvisionDrop(event: DragEvent) {
    event.preventDefault();
    this.copyProvisionDragging = false;
    if (this.copyProvisionLoading) return;
    const files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 1) {
      this.resetCopyProvisionSelection();
      this.copyProvisionError = 'Select one provision JSON file at a time.';
      return;
    }
    this.loadCopyProvisionFile(files && files[0]);
  }

  private resetCopyProvisionSelection() {
    ++this.copyProvisionFileReadId;
    this.copyProvisionFileReading = false;
    this.copyProvisionFileName = '';
    this.copyProvisionDragging = false;
    this.copyProvisionDocument = undefined;
    this.copyProvisionTokens = [];
    this.copyProvisionError = '';
    this.copyProvisionMessage = '';
  }

  private loadCopyProvisionFile(file: File) {
    this.resetCopyProvisionSelection();
    if (!file) return;
    if (!/\.json$/i.test(file.name)) {
      this.copyProvisionError = 'Select a .json provision file.';
      return;
    }

    const readId = this.copyProvisionFileReadId;
    this.copyProvisionFileName = file.name;
    this.copyProvisionFileReading = true;
    const reader = new FileReader();
    reader.onload = () => {
      if (readId !== this.copyProvisionFileReadId) return;
      this.copyProvisionFileReading = false;
      this.parseCopyProvisionFileContent(String(reader.result).replace(/^\uFEFF/, ''));
    };
    reader.onerror = () => {
      if (readId !== this.copyProvisionFileReadId) return;
      this.copyProvisionFileReading = false;
      this.copyProvisionError = 'Unable to read the selected file. Please select it again.';
    };
    reader.readAsText(file);
  }

  private parseCopyProvisionFileContent(value: string) {
    if (!value.trim()) {
      this.copyProvisionError = 'The selected file is empty. Select a provision JSON file.';
      return;
    }

    let data;
    try {
      data = JSON.parse(value);
    } catch (err) {
      this.copyProvisionError = 'Invalid JSON: ' + err.message + '. Use MongoDB Extended JSON ($date / $binary) for BSON values; shell functions such as ISODate() and BinData() are not JSON.';
      return;
    }

    const formatted = JSON.stringify(data, null, 2);
    // Tokens are rendered as text, so file contents are never interpreted as HTML.
    const pattern = /("(?:\\.|[^"\\])*"\s*:|"(?:\\.|[^"\\])*"|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?|\btrue\b|\bfalse\b|\bnull\b)/g;
    this.copyProvisionTokens = formatted.split(pattern).filter(text => text !== '').map(text => ({
      text,
      color: /^"/.test(text) ? (/:$/.test(text) ? '#9cdcfe' : '#ce9178') :
        /^(true|false|null)$/.test(text) ? '#569cd6' : /^-?\d/.test(text) ? '#b5cea8' : '#d4d4d4'
    }));
    if (!data || typeof data !== 'object' || Array.isArray(data) ||
        typeof data._id !== 'string' || !data._id.trim()) {
      this.copyProvisionError = 'Provide a JSON object with a non-empty string _id.';
      return;
    }
    const formatError = getProvisionFormatError(data);
    if (formatError) {
      this.copyProvisionError = formatError;
      return;
    }
    this.copyProvisionDocument = data;
  }

  copyProvisionData() {
    if (!this.showCopyProvisionData || this.copyProvisionLoading || this.copyProvisionFileReading || !this.copyProvisionDocument) {
      return;
    }
    this.copyProvisionLoading = true;
    this.copyProvisionError = '';
    this.copyProvisionMessage = '';
    this.http.post(this.env.apiUrl + '/api/hubTransfer/copyProvisionData', {
      data: this.copyProvisionDocument
    }).subscribe(response => {
      this.copyProvisionLoading = false;
      this.resetCopyProvisionSelection();
      this.copyProvisionMessage = response['message'];
    }, err => {
      this.copyProvisionLoading = false;
      this.copyProvisionError = err.error && err.error.message ? err.error.message : 'Failed to copy provision data. Please try again.';
    });
  }

  reloadEverything(){
    this.getAccessList();
    //this.getAccessListTaken();
    this.getSupportGuys();
    this.getDevelopers();
    this.checkRoles();
    this.getTodaysConsolePin();
    this.getImpPasswdInit()
  }

  onGridReady(params: GridReadyEvent) {
    //params.columnApi.autoSizeColumns(['feedback.dislike']);
  }

  showAllHealthDataChangeHub(checked){
    this.showAllData = checked;
  }

  toggleSearch(){
    this.showSearchCard = true;
  }


  isOperator(place){
    return localStorage.getItem("emailId") == place.currentOperatorEmail
  }

  isChild(place){
    return place.children.includes(localStorage.getItem("emailId"))
  }


  searchUsers(query: string) {
    // console.log("search Users: " + query)
    this.searchValue = query
    this.userQuerySubject.next(this.searchValue + "," + false + "," + false + ',' + 0 + "," + 10);
  }

  private userQuerySubject = new Subject<string>();

  readonly custDatas$ = this.userQuerySubject.pipe(
    liveSearch(query => this.dashService.fetchUsers(query))
  );

  setData(item: any) {
    console.log(item);
    
    this.customer = {contact:item['emailId'] ? item['emailId'] : item['mobile'],_id:item['_id']};
    this.showSearchCard = false;
  }

  addNodeUtil(){
    if(this.oldEid == "" || this.newEid == "" || this.oldEid == undefined || this.newEid == undefined){
      this.userDetails.showToast(3000,"Node Replacement","Old and New eID can not be empty")
      return
    }

    this.oldEid = chunkSubstr(this.oldEid.replace(/:/g,"").replace(/-/g,"").toLowerCase(),2).join("-");
    this.newEid = chunkSubstr(this.newEid.replace(/:/g,"").replace(/-/g,"").toLowerCase(),2).join("-");

    if(this.oldEid == this.newEid){
      this.userDetails.showToast(3000,"Node Replacement","Old and New eID can not be same")
      return
    }
    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.oldEid)){
      this.userDetails.showToast(3000,"Node Replacement","Old eID is not valid eGlu eID")
      return
    }
    if(!regex.test(this.newEid)){
      this.userDetails.showToast(3000,"Node Replacement","New eID is not valid eGlu eID")
      return
    }
    this.nodeIds[this.oldEid] = {eid:this.newEid,deductWarranty:true,reason:""}
    this.newEid = "";
    this.oldEid = "";
  }

  isReplacing = false;

  selectFeature(feature){
    this.selectedFeature = feature;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  getSceneDetails(){
    if(!this.sceneHubId || !this.sceneName.trim()) {
      this.userDetails.showToast(3000,"Scene Details","Hub ID and scene name can not be empty");
      return;
    }

    const hubId = this.sceneHubId.toLowerCase().replace(/:/g,"-").replace(/ /g,"");
    const hubIdRegex = /^[a-zA-Z0-9]{2}(-[a-zA-Z0-9]{2}){7}$/;
    if(!hubIdRegex.test(hubId)) {
      this.userDetails.showToast(3000,"Scene Details","Hub ID is not valid. Please enter a dash-separated Hub ID");
      return;
    }

    this.sceneHubId = hubId;
    this.sceneData = undefined;
    this.sceneEdgeDataRows = [];
    this.sceneDetailsLoading = true;
    this.http.get(
      this.env.apiUrl + "/api/hubTransfer/scene?hubId=" +
      encodeURIComponent(hubId) + "&name=" + encodeURIComponent(this.sceneName.trim())
    ).subscribe(response => {
      this.sceneDetailsLoading = false;
      this.sceneData = response["scene"];
      this.sceneEdgeDataRows = this.getSceneEdgeDataRows(this.sceneData.edgeData);
    }, err => {
      this.sceneDetailsLoading = false;
      const message = err.error && err.error.message ? err.error.message : "Failed to fetch scene details";
      this.userDetails.showToast(4000,"Scene Details",message);
    });
  }

  getSceneEdgeDataRows(edgeData){
    const shortIds = edgeData && edgeData.shortId ? edgeData.shortId : {};
    const edgeSync = edgeData && edgeData.edgeSync ? edgeData.edgeSync : {};
    const hubIds = {};

    Object.keys(shortIds).forEach(hubId => hubIds[hubId] = true);
    Object.keys(edgeSync).forEach(hubId => hubIds[hubId] = true);

    return Object.keys(hubIds).map(hubId => ({
      hubId: hubId,
      shortId: shortIds[hubId],
      edgeSync: edgeSync[hubId]
    }));
  }

  getAppActionTypeName(type){
    return Number.isInteger(type) && this.appActionTypes[type]
      ? this.appActionTypes[type]
      : "UNKNOWN";
  }

  refreshOtaBucket(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/refreshOtaBucket")
              .subscribe(response => {
                console.log(response);
                this.userDetails.showToast(2000, "Refresh OTA Bucket", "OTA Buckets are refreshed successfully.");
              }, err => {
                console.log(err);
              })
  }

  accept(place:any){
    var pin = prompt("Please enter support access pin to continue.")
    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.loadingAccessRequest = true;
          this.http.get(this.env.apiUrl + "/api/hubTransfer/support-access?requestId="+place.requestId+"&given=1&placeId="+place.placeId)
              .subscribe(response => {
                this.loadingAccessRequest = true;
                console.log(response);
                this.reloadEverything();
              }, err => {
                this.loadingAccessRequest = true;
                console.log(err);
              })
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
    }
  }

  drop(place:any){
    var pin = prompt("Please enter Console Advanced User Passcode to continue.")
    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.loadingAccessRequest = true;
          this.http.get(this.env.apiUrl + "/api/hubTransfer/drop-access?requestId="+place.requestId+"&placeId="+place.placeId)
              .subscribe(response => {
                this.loadingAccessRequest = true;
                console.log(response);
                this.reloadEverything();
              }, err => {
                this.loadingAccessRequest = true;
                console.log(err);
              })
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
    }
  }

  transferInternal(place:any){
    var pin = prompt("Please enter support access pin to continue.")
    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.loadingAccessRequest = true;
          this.http.get(this.env.apiUrl + "/api/hubTransfer/transfer-access?requestId="+place.requestId+"&placeId="+place.placeId+"&toEmail="+encodeURIComponent(this.selectedSupportGuy))
              .subscribe(response => {
                this.loadingAccessRequest = true;
                console.log(response);
                this.reloadEverything();
              }, err => {
                this.loadingAccessRequest = true;
                console.log(err);
              })
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
    }
  }

  transferEngineering(place:any){
    var pin = prompt("Please enter support access pin to continue.")
    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.loadingAccessRequest = true;
          this.http.get(this.env.apiUrl + "/api/hubTransfer/add-child?requestId="+place.requestId+"&placeId="+place.placeId+"&cEmail="+encodeURIComponent(this.selectedDeveloper))
              .subscribe(response => {
                this.loadingAccessRequest = true;
                console.log(response);
                this.reloadEverything();
              }, err => {
                this.loadingAccessRequest = true;
                console.log(err);
              })
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
    }
  }

  removeChild(place:any,email){
    var pin = prompt("Please enter support access pin to continue.")
    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.loadingAccessRequest = true;
          this.http.get(this.env.apiUrl + "/api/hubTransfer/remove-child?requestId="+place.requestId+"&placeId="+place.placeId+"&cEmail="+encodeURIComponent(email))
              .subscribe(response => {
                this.loadingAccessRequest = true;
                console.log(response);
                this.reloadEverything();
              }, err => {
                this.loadingAccessRequest = true;
                console.log(err);
              })
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
    }
  }

  triggerPush(place:any){
    var pin = prompt("Please enter support access pin to continue.")
    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.loadingAccessRequest = true;
          this.http.get(this.env.apiUrl + "/api/hubTransfer/trigger-push?requestId="+place.requestId)
              .subscribe(response => {
                this.loadingAccessRequest = true;
                console.log(response);
                this.reloadEverything();
              }, err => {
                this.loadingAccessRequest = true;
                console.log(err);
              })
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
    }
  }

  cancelRequest(place:any){
    var pin = prompt("Please enter support access pin to continue.")
    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.http.get(this.env.apiUrl + "/api/hubTransfer/drop-access?requestId="+place.requestId+"&placeId="+place.placeId)
              .subscribe(response => {
                this.loadingAccessRequest = true;
                console.log(response);
                this.reloadEverything();
              }, err => {
                this.loadingAccessRequest = true;
                console.log(err);
              })
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
    }
  }

  onChildRemove(place,child){
    this.removeChild(place,child);
  }

  reject(place:any){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/support-access?placeId="+place.placeId+"&given=0")
              .subscribe(response => {
                console.log(response);
                this.reloadEverything();
              }, err => {
                console.log(err);
              })
  }

  checkRoles(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/checkRole/support")
              .subscribe(response => {
                console.log(response);
                if(response["success"]){
                  this.isSupport = true;
                  this.features.unshift("Node Replacement")
                  this.selectedFeature = "Node Replacement"
                }else {
                  this.selectedFeature = "Provision"
                  //developer
                  let finalFeatures = [
                    "Provision",
                    "Com Decom History",
                    "Kit Info",
                    "Warranty",
                    "Batch Node OTA",
                    "Extract Node Type Data",
                    "Extract Customer Data",
                    "Health Data",
                    "Packet Analyzer",
                    "Refresh OTA Buckets"
                  ]
                  this.features = this.features.filter((feature)=>{
                    return finalFeatures.includes(feature)
                  })
                }
              }, err => {
                console.log(err);
                
              })

    this.http.get(this.env.apiUrl + "/api/hubTransfer/checkRole/developer")
              .subscribe(response => {
                console.log(response);
                if(response["success"]){
                  this.isDeveloper = true;
                }
              }, err => {
                console.log(err);
                
              })
  }

  getAccessList(){
    this.loadingAccessRequest = true;
    this.loadingAccessRequestTaken = true;
    this.loadingAccessRequestAsked = true;
    this.loadingAccessInternal = true;
    this.loadingAccessDeveloper = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/request-status")
              .subscribe(response => {
                console.log(response);
                this.data=response["data"].filter(request=>{
                  return request.currentState == "GIVEN_BY_USER"
                });
                this.dataTaken=response["data"].filter(request=>{
                  return request.currentState == "TAKEN_BY_SUPPORT"
                });
                this.dataAsked = response["data"].filter(request=>{
                  return request.currentState == "ASKED_BY_SUPPORT"
                })
                this.loadingAccessRequest = false;
                this.loadingAccessRequestTaken = false;
                this.loadingAccessRequestAsked = false;
                this.loadingAccessInternal = false;
                this.loadingAccessDeveloper = false;
              }, err => {
                console.log(err);
                this.loadingAccessRequest = false;
                this.loadingAccessRequestTaken = false;
                this.loadingAccessRequestAsked = false;
                this.loadingAccessInternal = false;
                this.loadingAccessDeveloper = false;
              })
  }

  getAccessListTaken(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/request-status-taken")
              .subscribe(response => {
                console.log(response);
                this.dataTaken=response["data"];
                this.loadingAccessRequestTaken = false;
              }, err => {
                console.log(err);
                this.loadingAccessRequestTaken = false;
              })
  }

  extractNodeType(){
    if(this.extractNodeTypes == "") {
      this.userDetails.showToast(3000,"Extract Node Type Data","Node Types can not be empty");
      return;
    }
    if(this.extractNodeTypeReason == "") {
      this.userDetails.showToast(3000,"Extract Node Type Data","Reason can not be empty");
      return;
    }
    this.extractNodeTypeLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/extractNodeTypeData",{types:this.extractNodeTypes,reason:this.extractNodeTypeReason})
              .subscribe(response => {
                this.extractNodeTypeReason = "";
                this.extractNodeTypes = "";
                console.log(response);
                if(response["success"]){
                  this.userDetails.showToast(9000,"Extract Node Type Data","You will get the extracted data via Mail shortly. It can take several minutes.");
                }
                this.extractNodeTypeLoading = false;
              }, err => {
                console.log(err);
                this.userDetails.showToast(4000,"Extract Node Type Data",err.response.data.message ?? "Failed to node type data. Please try again")
                this.extractNodeTypeReason = "";
                this.extractNodeTypes = "";
                this.extractNodeTypeLoading = false;
              })
  }

  extractCustomerData(){
    if(this.extractCustomerContact == "") {
      this.userDetails.showToast(3000,"Extract Customer Data","Customer contact can not be empty");
      return;
    }
    if(this.extractCustomerDataReason == "") {
      this.userDetails.showToast(3000,"Extract Customer Data","Reason can not be empty");
      return;
    }
    this.extractCustomerDataLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/extractCustomerData",{customerContact:this.extractCustomerContact,reason:this.extractCustomerDataReason})
              .subscribe(response => {
                this.extractCustomerDataReason = "";
                this.extractCustomerContact = "";
                console.log(response);
                if(response["success"]){
                  this.userDetails.showToast(9000,"Extract Customer Data","You will get the extracted data via Mail shortly. It can take several minutes.");
                }
                this.extractCustomerDataLoading = false;
              }, err => {
                console.log(err);
                this.userDetails.showToast(4000,"Extract Customer Data",err.response.data.message ?? "Failed to extract customer data. Please try again")
                this.extractCustomerDataReason = "";
                this.extractCustomerContact = "";
                this.extractCustomerDataLoading = false;
              })
  }

  removeEidFromBatchNodeOTAList(eid){
    let temp = this.batchNodeOTAEids.filter(eidR=>{
      return eidR != eid;
    })
    this.batchNodeOTAEids = temp;
  }

  addEidToBatchNodeOTAList(){
    if(this.batchNodeOTAEid == "" || this.batchNodeOTAEid == undefined){
      return;
    }
    let eidsTemp = this.batchNodeOTAEid;
    let eidsTemp2 = eidsTemp.split(",")
    let eids = [];
    for(const eid of eidsTemp2){
      if(eid != "") {
        let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
        if(!regex.test(eid)){
          continue;
        }
        eids.push(eid.toLowerCase().replace(/:/g,"").trim());
      }
    }
    this.batchNodeOTAEids = this.batchNodeOTAEids.concat(eids);
    this.batchNodeOTAEid = "";
  }

  batchNodeOTAPendingRequest(){
    this.batchNodeOTARequestsLoading = true;
    this.http.get(this.env.apiUrl + "/api/sendCommand/batchNodeOTAPendingRequests")
              .subscribe(response => {
                console.log(response);
                this.batchNodeOTARequestsLoading = false;
                this.batchNodeOTARequests = response["requests"];
              }, err => {
                console.log(err);
                this.batchNodeOTARequestsLoading = false;
              })
  }

  batchNodeOTARequest(){
    this.batchNodeOTALoading = true;
    this.http.post(this.env.apiUrl + "/api/sendCommand/batchNodeOTA",{eids:this.batchNodeOTAEids})
              .subscribe(response => {
                console.log(response);
                this.batchNodeOTALoading = false;
                this.userDetails.showToast(5000,"Batch Node OTA",response["message"])
                this.batchNodeOTAEid = "";
                this.batchNodeOTAEids = [];
              }, err => {
                console.log(err);
                this.batchNodeOTALoading = false;
              })
  }

  unlockKit(){
    if(this.unlockKitHubId == "") {
      this.userDetails.showToast(3000,"Unlock Kit","HUB ID can not be empty");
      return;
    }

    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.unlockKitHubId)){
      this.userDetails.showToast(3000,"Unlock Kit","HUB ID is not valid.Please enter HUB ID dash separated.")
      return
    }

    if(this.unlockKitReason == "") {
      this.userDetails.showToast(3000,"Unlock Kit","Reason can not be empty");
      return;
    }

    if(this.unlockKitApprover == "") {
      this.userDetails.showToast(3000,"Unlock Kit","Approver can not be empty");
      return;
    }
    this.unlockKitLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/unlockKit",{hubId:this.unlockKitHubId.toLowerCase().replace(/:/g,"-").replace(/ /g,""),reason:this.unlockKitReason,approver:this.unlockKitApprover})
              .subscribe(response => {
                this.unlockKitHubId = "";
                this.unlockKitReason = "";
                this.unlockKitApprover = "";
                console.log(response);
                if(response["success"]){
                  this.userDetails.showToast(4000,"Unlock Kit","Successfully unlocked eGlu Kit");
                }
                this.unlockKitLoading = false;
              }, err => {
                console.log(err);
                this.userDetails.showToast(4000,"Unlock Kit",err.response.data.message ?? "Failed to unlock Kit. Please try again")
                this.unlockKitHubId = "";
                this.unlockKitApprover = "";
                this.unlockKitReason = "";
                this.unlockKitLoading = false;
              })
  }

  deblacklist(){
    if(this.deblacklistEid == "") {
      this.userDetails.showToast(3000,"De-BlackList","eID can not be empty");
      return;
    }
    if(this.deblacklistReason == "") {
      this.userDetails.showToast(3000,"De-BlackList","Reason can not be empty");
      return;
    }
    this.deBlackListingLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/deblacklist",{eid:this.deblacklistEid.toLowerCase().replace(/:/g,"-").replace(/ /g,""),reason:this.deblacklistReason})
              .subscribe(response => {
                this.deblacklistEid = "";
                this.deblacklistReason = "";
                console.log(response);
                if(response["success"]){
                  this.userDetails.showToast(4000,"De-BlackList","Successfully deblacklisted eGlu Device");
                }
                this.deBlackListingLoading = false;
              }, err => {
                console.log(err);
                this.userDetails.showToast(4000,"De-BlackList",err.response.data.message ?? "Failed to De-BlackList eGlu Device. Please try again")
                this.deblacklistEid = "";
                this.deblacklistReason = "";
                this.deBlackListingLoading = false;
              })
  }

  changeHubVariant(){
    if(this.hubVariantEid == "") {
      this.userDetails.showToast(3000,"Fix HUB Variant","eID can not be empty");
      return;
    }
    this.hubVariantChangeLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/changeHubVariant",{eid:this.hubVariantEid.toLowerCase().replace(/:/g,"-").replace(/ /g,"")})
              .subscribe(response => {
                this.hubVariantEid = "";
                console.log(response);
                if(response["success"]){
                  this.userDetails.showToast(4000,"Fix HUB Variant","Successfully changed variant of eGlu HUB");
                }
                this.hubVariantChangeLoading = false;
              }, err => {
                console.log(err);
                this.userDetails.showToast(4000,"Fix HUB Variant",err.response.data.message ?? "Failed to change variant of eGlu HUB. Please try again")
                this.hubVariantEid = "";
                this.hubVariantChangeLoading = false;
              })
  }

  checkWarranty(){
    if(this.warrantyEid == "" || this.warrantyEid == undefined) {
      this.userDetails.showToast(3000,"Warranty Check","eID can not be empty");
      return;
    }
    this.warrantyEid = chunkSubstr(this.warrantyEid.replace(/:/g,"").replace(/-/g,"").toLowerCase(),2).join("-");

    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.warrantyEid)){
      this.userDetails.showToast(3000,"Warranty Check","eID is not valid")
      return
    }
    this.warrantyEid = this.warrantyEid.replace(/-/g,"").replace(/:/g,"").toLowerCase();
    this.warrantyLoading = true;
    //97:71:e0:f5:58:c3:e5:8f
    this.http.get(this.env.apiUrl + "/api/hubTransfer/warranty/"+this.warrantyEid)
              .subscribe(response => {
                this.warrantyEid = "";
                console.log(response);
                if(response["success"]){
                  this.isWarrantyGood = 1;
                  this.warrantyMessage = response["message"];
                  if(response["warning"]) {
                    this.isWarrantyGood = -2;
                  }
                }else {
                  this.isWarrantyGood = -1;
                  this.warrantyMessage = response["message"];
                }
                this.warrantyLoading = false;
              }, err => {
                console.log(err);
                this.warrantyEid = "";
                this.warrantyLoading = false;
              })
  }

  getSupportGuys(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/support-transfer/internal/list")
              .subscribe(response => {
                console.log(response);
                this.dataSupportGuys=response["supportGuys"];
                this.loadingAccessRequestInternalTransfer = false;
                this.dataSupportGuys = this.dataSupportGuys.filter(guy=>{
                  return guy != localStorage.getItem("emailId");
                })
              }, err => {
                console.log(err);
                this.loadingAccessRequestInternalTransfer = false;
              })
  }

  getDevelopers(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/support-transfer/developers/list")
              .subscribe(response => {
                console.log(response);
                this.dataDevelopers=response["developers"];
                this.loadingAccessRequestDeveloperTransfer = false;
                this.dataDevelopers = this.dataDevelopers.filter(guy=>{
                  return guy != localStorage.getItem("emailId");
                })
              }, err => {
                console.log(err);
                this.loadingAccessRequestDeveloperTransfer = false;
              })
  }

  getPlaceAuditData(){
    if(this.auditPlaceId == "") {
      return
    }
    this.loadingAccessRequestAudit = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/place-audit?placeId="+this.auditPlaceId)
              .subscribe(response => {
                console.log(response);
                this.dataAudit=response["data"];
                this.loadingAccessRequestAudit = false;
                this.auditPlaceId = "";

              }, err => {
                console.log(err);
                this.loadingAccessRequestAudit = false;
              })
  }

  getNRHistory(){
    if(this.nrHistoryEid == "") {
      this.userDetails.showToast(3000,"Node Replacement History","Not a valid eID")
      return;
    }

    this.nrHistoryEid = this.nrHistoryEid.replace(/:/g,"").replace(/-/g,"").toLowerCase();
    this.loadingReplacement=true;
    this.http.get(this.env.apiUrl+"/api/users/nodeReplacementHistory/" + chunkSubstr(this.nrHistoryEid,2).join("-"))
    .subscribe(response=>{
      // console.log("nodeHistory response "+JSON.stringify(response));
      this.localDataReplacement = response
      this.setReplacementHistory();
      this.loadingReplacement=false;
    },err=>{
      console.log(err);
      this.loadingReplacement=false;
    })
  }

  isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  setReplacementHistory(){
    var history=this.localDataReplacement.history;
    console.log("node replacement history ",history);
    
    for(var i=0;i<history.length;i++){
      let item = history[i];
      this.dataSourceForReplacement.push({
        'oldEid':item.oldNodeEid,
        'newEid': item.newNodeEid,
        'invokerId':item.invokerId,
        'reason':this.isValidEmail(item.reason) ? item.customerEmail : item.reason,
        "customerEmail":!this.isValidEmail(item.reason) ? item.customerEmail : item.reason,
        'initiationDate':item.initiationDate,
        'completionDate':item.completionDate,
        'newNodeShortId':item.newNodeShortId,
        'oldNodeShortId':item.oldNodeShortId
      })
    }
    this.dataSourceForReplacement.sort(function(a,b){return b.createdAt>a.createdAt?1:-1});
  }

  checkProvision(){
    if(this.provisionEid == "") {
      this.userDetails.showToast(3000,"Provision","Not a valid eID")
      return;
    }

    this.provisionEid = this.provisionEid.replace(/:/g,"").replace(/-/g,"").toLowerCase();

    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    let regex2 = new RegExp("[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}")
    let regex3 = new RegExp("[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}")
    if(!regex3.test(this.provisionEid)){
      this.userDetails.showToast(3000,"Provision","Not a valid eID")
      return
    }
    this.provisionLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/getProvision",{eid:this.provisionEid})
              .subscribe(response => {
                console.log(response);
                this.provisionLoading = false;
                this.provisionData = response["data"];
                this.provisionData["comDecomHistory"].reverse();
                console.log(this.provisionData);
                
              }, err => {
                console.log(err);
                this.provisionLoading = false;
              })
  }

  downloadProvision(){
    if(this.provisionEid == "") {
      this.userDetails.showToast(3000,"Provision","Not a valid eID")
      return;
    }

    this.provisionEid = this.provisionEid.replace(/:/g,"").replace(/-/g,"").toLowerCase();

    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    let regex2 = new RegExp("[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}")
    let regex3 = new RegExp("[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}")
    if(!regex3.test(this.provisionEid)){
      this.userDetails.showToast(3000,"Provision","Not a valid eID")
      return
    }
    this.provisionLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/downloadProvision",{eid:this.provisionEid})
              .subscribe(response => {
                console.log(response);
                this.provisionLoading = false;
                this.provisionDataDownload = response["data"];
                var data = JSON.stringify(this.provisionDataDownload,null,2);
                  const blob = new Blob([data], { type: 'application/json' });
                  const url= window.URL.createObjectURL(blob);
                  let a = document.createElement("a");
                  a.href = url;
                  a.download = this.provisionEid.replace(/:/g,"").replace(/-/g,"").toLowerCase()+"_data.json";
                  a.click();
              }, err => {
                console.log(err);
                this.provisionLoading = false;
              })
  }

  downloadTestData(){
    if(this.provisionEid == "") {
      this.userDetails.showToast(3000,"Test Data","Not a valid eID")
      return;
    }

    this.provisionEid = this.provisionEid.replace(/:/g,"").replace(/-/g,"").toLowerCase();

    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    let regex2 = new RegExp("[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}:[a-zA-Z0-9]{2}")
    let regex3 = new RegExp("[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}[a-zA-Z0-9]{2}")
    if(!regex3.test(this.provisionEid)){
      this.userDetails.showToast(3000,"Test Data","Not a valid eID")
      return
    }
    this.provisionLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/downloadTestData",{eid:this.provisionEid})
              .subscribe(response => {
                console.log(response);
                this.provisionLoading = false;
                this.provisionDataDownload = response["data"];
                var data = JSON.stringify(this.provisionDataDownload,null,2);
                  const blob = new Blob([data], { type: 'application/json' });
                  const url= window.URL.createObjectURL(blob);
                  let a = document.createElement("a");
                  a.href = url;
                  a.download = this.provisionEid.replace(/:/g,"").replace(/-/g,"").toLowerCase()+"_test_data.json";
                  a.click();
              }, err => {
                console.log(err);
                this.provisionLoading = false;
              })
  }

  getComDecomHistory(){
    if(this.comDecomEid == "" || this.comDecomEid == undefined) {
      this.userDetails.showToast(3000,"Com/Decom History","Not a valid eID")
      return;
    }
    this.comDecomEid = chunkSubstr(this.comDecomEid.replace(/:/g,"").replace(/-/g,"").toLowerCase(),2).join("-")
    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.comDecomEid)){
      this.userDetails.showToast(3000,"Com/Decom History","Not a valid eID")
      return
    }
    this.comDecomHistoryLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/comDecomHistory",{eid:this.comDecomEid})
              .subscribe(response => {
                console.log(response);
                this.comDecomHistoryLoading = false;
                this.comDecomData = response["data"];
                this.comDecomData.forEach(data=>{
                  data["date"] = moment(data["date"]).format("lll");
                })
                console.log(this.comDecomData);
                this.comDecomEid = "";
              }, err => {
                console.log(err);
                this.comDecomHistoryLoading = false;
              })
  }

  getServiceTestingAll(){
    
    this.serviceTestingLoading = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/serviceTesting?eid=all")
              .subscribe(response => {
                console.log(response);
                this.serviceTestingLoading = false;
                this.serviceTestingData = response["data"];
                this.serviceTestingData.forEach(data=>{
                  data["markedAt"] = moment(data["markedAt"]).format("lll");
                })
                console.log(this.serviceTestingData);
                this.serviceTestingEid = "";
              }, err => {
                console.log(err);
                this.serviceTestingLoading = false;
              })
  }

  getServiceTesting(){
    if(this.serviceTestingEid == "") {
      this.userDetails.showToast(3000,"Service Testing","Not a valid eID")
      return;
    }

    this.serviceTestingLoading = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/serviceTesting?eid="+this.serviceTestingEid.toLowerCase().replace(/:/g,"").replace(/-/g,""))
              .subscribe(response => {
                console.log(response);
                this.serviceTestingLoading = false;
                this.serviceTestingData = response["data"];
                this.serviceTestingData.forEach(data=>{
                  data["markedAt"] = moment(data["markedAt"]).format("lll");
                })
                console.log(this.serviceTestingData);
                this.serviceTestingEid = "";
              }, err => {
                console.log(err);
                this.serviceTestingLoading = false;
              })
  }

  getLockedAccounts(){
    this.lockedAccountsLoading = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/blockedHubs")
              .subscribe(response => {
                console.log(response);
                this.lockedAccountsLoading = false;
                this.lockedAccounts = response["data"];
                this.lockedAccounts.forEach(data=>{
                  if(data["updatedAt"]) {
                    data["updatedAt"] = moment(data["updatedAt"]).format("lll");
                  }
                  data["blockFunctionality"]=data["blockFunctionality"] == true ? "YES" : "NO"
                })
              }, err => {
                console.log(err);
                this.lockedAccountsLoading = false;
              })
  }

  setServiceTesting(){
    if(this.serviceTestingEidAdding == "") {
      this.userDetails.showToast(3000,"Service Testing","Not a valid eID")
      return;
    }

    if(this.serviceTestingComment == "") {
      this.userDetails.showToast(3000,"Service Testing","Not a valid comment")
      return;
    }

    this.serviceTestingLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/serviceTesting",{eid:this.serviceTestingEidAdding.toLowerCase().replace(/:/g,"").replace(/-/g,""),comment:this.serviceTestingComment})
              .subscribe(response => {
                console.log(response);
                this.serviceTestingLoading = false;
                this.serviceTestingEidAdding = "";
                this.serviceTestingComment = "";
                this.userDetails.showToast(3000,"Service Testing","Successfully marked as Testing required")
              }, err => {
                console.log(err);
                this.serviceTestingLoading = false;
                this.userDetails.showToast(3000,"Service Testing","Failed to mark as Testing required.")
              })
  }

  getKitInfo(){
    if(this.kitHubId == "" || this.kitHubId == undefined) {
      this.userDetails.showToast(3000,"Kit Info","Not a valid eID")
      return;
    }
    this.kitHubId = chunkSubstr(this.kitHubId.replace(/:/g,"").replace(/-/g,"").toLowerCase(),2).join("-")
    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.kitHubId)){
      this.userDetails.showToast(3000,"Kit Info","Not a valid HUB ID.")
      return
    }
    this.kitInfoLoading = true;
    this.kitData = [];
    this.http.get(this.env.apiUrl + "/api/hubTransfer/kitInfo?hubId="+this.kitHubId.replace(/:/g,'-'))
              .subscribe(response => {
                console.log(response);
                this.kitInfoLoading = false;
                let result = response["info"];
                this.kitData = [];
                result.nodeIds.forEach(node=>{
                  this.kitData.push({
                    nodeId:node.nodeId,
                    type:node.type,
                    date: moment(result["createdAt"]).format("lll"),
                    configId:result["configId"]
                  })
                })
                console.log(this.kitData);
              }, err => {
                console.log(err);
                this.kitInfoLoading = false;
              })
  }

  getBeautifiedComDecomHistory(history){
    return (history["type"] == "com" ? "➕" : "➖") +" "+(history["type"] == "com" ? "Commission" : (history["type"] == "proddecom" ? "Prod Decommission" : "Decommission")) + " at "+history["time"] + (history["byName"] == undefined ? "" : " by "+history["byName"])
  }

  downloadLogs(){
    if(this.auditPlaceId == "") {
      return
    }
    this.loadingAccessRequestAudit = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/download-log?placeId=",{placeId:this.auditPlaceId,auditDate:this.auditDate})
              .subscribe(response => {
                console.log(response);
                if(response["finalData"].length > 0){
                  var data = JSON.stringify(response["finalData"],null,2);
                  const blob = new Blob([data], { type: 'application/json' });
                  const url= window.URL.createObjectURL(blob);
                  
                  let a = document.createElement("a");
                  a.href = url;
                  a.download = this.auditPlaceId+"_logs.json";
                  a.click();
                }else {
                  this.userDetails.showToast(3000,"Support Access","No support access logs were found for this place.")
                }
                this.loadingAccessRequestAudit = false;
                this.auditPlaceId = "";
              }, err => {
                console.log(err);
                this.loadingAccessRequestAudit = false;
                this.userDetails.showToast(4000,"Support Access",err.data?.message ?? "Failed to download logs. Please try again")
              })
  }

  toggledeductWarranty(checked:boolean,key) {
    this.deductWarranty = checked;
    this.nodeIds[key].deductWarranty = checked;
  }

  loadingCustomerInfo = false;
  customerContact = "";
  dataCustomer = {};
  selectedHubId = undefined;
  selectedPlaceId = undefined;

  changeHubPlace(){
    if(!this.selectedHubId || !this.selectedPlaceId){
      this.userDetails.showToast(3000,"Change HUB's Place","Please select both HUB ID and Place");
      return
    }
    this.loadingCustomerInfo = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/changeHubPlace/commit",{selectedHubId:this.selectedHubId,selectedPlaceId:this.selectedPlaceId,contact:this.customerContact})
              .subscribe(response => {
                console.log(response);
                
                this.loadingCustomerInfo = false;
                this.userDetails.showToast(4000,"Change HUB's Place","Place is changed successfully");
                this.selectedHubId = undefined;
                this.selectedPlaceId = undefined;
                this.dataCustomer = {};
                this.customerContact = "";
              }, err => {
                console.log(err);
                this.loadingCustomerInfo = false;
              })
  }

  getHubsAndPlaces(){
    if(this.customerContact == ""){
      this.userDetails.showToast(3000,"Change HUB's Place","Contact can not be empty");
      return
    }
    this.dataCustomer={};
    this.selectedHubId = undefined;
    this.selectedPlaceId = undefined;
    this.loadingCustomerInfo = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/changeHubPlace",{contact:this.customerContact})
              .subscribe(response => {
                console.log(response);
                this.dataCustomer=response;
                this.loadingCustomerInfo = false;
                console.log(this.dataCustomer);
              }, err => {
                console.log(err);
                this.loadingCustomerInfo = false;
              })
  }

  changeFirstComDateV1(){
    if(this.firstComDateChangeEid == ""){
      this.userDetails.showToast(3000,"Change First Commission Date","eID can not be empty");
      return;
    }
    if(this.firstComDateChangeContact == ""){
      this.userDetails.showToast(3000,"Change First Commission Date","Contact can not be empty");
      return;
    }
    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.firstComDateChangeEid)){
      this.userDetails.showToast(3000,"Change First Commission Date","eID is not valid")
      return
    }
    if(this.firstComDateChangeDate == undefined){
      this.userDetails.showToast(3000,"Change First Commission Date","Date can not be empty");
      return;
    }

    if(this.firstComDateChangeTime == undefined){
      this.userDetails.showToast(3000,"Change First Commission Date","Time can not be empty");
      return;
    }
    
    this.firstComDateChangeDate.setHours(parseInt(this.firstComDateChangeTime.split(":")[0]));
    this.firstComDateChangeDate.setMinutes(parseInt(this.firstComDateChangeTime.split(":")[1]));

    this.firstComDateChangeLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/changeFirstComDate",{eid:this.firstComDateChangeEid,date:this.firstComDateChangeDate,contact:this.firstComDateChangeContact})
        .subscribe(response => {
          // console.log(response);
          this.firstComDateChangeLoading = false;
          this.firstComDateChangeDate = undefined;
          this.firstComDateChangeEid = "";
          this.firstComDateChangeContact = "";
          this.firstComDateChangeTime = undefined;
          this.userDetails.showToast(3000,"Change First Commission Date","First Commission Date is changed successfully");
        }, err => {
          console.log(err);
          this.firstComDateChangeLoading = false;
          this.userDetails.showToast(3000,"Change First Commission Date","Failed to change First Commission Date");
        })
  }

  changeFirstComDateV1Hub(){
    if(this.firstComDateChangeHub == ""){
      this.userDetails.showToast(3000,"Change First Commission Date","eID can not be empty");
      return;
    }
    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.firstComDateChangeHub)){
      this.userDetails.showToast(3000,"Change First Commission Date","eID is not valid")
      return
    }
    if(this.firstComDateChangeDateHub == undefined){
      this.userDetails.showToast(3000,"Change First Commission Date","Date can not be empty");
      return;
    }

    if(this.firstComDateChangeTimeHub == undefined){
      this.userDetails.showToast(3000,"Change First Commission Date","Time can not be empty");
      return;
    }
    
    this.firstComDateChangeDateHub.setHours(parseInt(this.firstComDateChangeTimeHub.split(":")[0]));
    this.firstComDateChangeDateHub.setMinutes(parseInt(this.firstComDateChangeTimeHub.split(":")[1]));

    this.firstComDateChangeLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/changeFirstComDateHub",{eid:this.firstComDateChangeHub,date:this.firstComDateChangeDateHub})
        .subscribe(response => {
          // console.log(response);
          this.firstComDateChangeLoading = false;
          this.firstComDateChangeDateHub = undefined;
          this.firstComDateChangeHub = "";
          this.firstComDateChangeTimeHub = undefined;
          this.userDetails.showToast(3000,"Change First Commission Date","First Commission Date is changed successfully");
        }, err => {
          console.log(err);
          this.firstComDateChangeLoading = false;
          this.userDetails.showToast(3000,"Change First Commission Date","Failed to change First Commission Date");
        })
  }

  changeFirstComDate(){
    if(this.firstComDateChangeEid == ""){
      this.userDetails.showToast(3000,"Extended Warranty","eID can not be empty");
      return;
    }

    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.firstComDateChangeEid)){
      this.userDetails.showToast(3000,"Extended Warranty","eID is not valid")
      return
    }
    if(this.firstComDateChangeDate == undefined){
      this.userDetails.showToast(3000,"Extended Warranty","Date can not be empty");
      return;
    }

    this.firstComDateChangeLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/extendedWarranty",{eid:this.firstComDateChangeEid,date:this.firstComDateChangeDate})
        .subscribe(response => {
          // console.log(response);
          this.firstComDateChangeLoading = false;
          this.firstComDateChangeDate = undefined;
          this.firstComDateChangeEid = "";
          this.firstComDateChangeContact = "";
          this.firstComDateChangeTime = undefined;
          this.userDetails.showToast(3000,"Extended Warranty","Warranty Expiry Date is changed successfully");
        }, err => {
          console.log(err);
          this.firstComDateChangeLoading = false;
          this.userDetails.showToast(3000,"Extended Warranty","Failed to change Warranty Expiry Date");
        })
  }

  changeFirstComDateHub(){
    if(this.extWarrantyDateChangeEidHub == ""){
      this.userDetails.showToast(3000,"Extended Warranty","eID can not be empty");
      return;
    }

    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.extWarrantyDateChangeEidHub)){
      this.userDetails.showToast(3000,"Extended Warranty","eID is not valid")
      return
    }
    if(this.extWarrantyDateChangeHub == undefined){
      this.userDetails.showToast(3000,"Extended Warranty","Date can not be empty");
      return;
    }

    this.firstComDateChangeLoading = true;
    this.http.post(this.env.apiUrl + "/api/hubTransfer/extendedWarrantyHub",{eid:this.extWarrantyDateChangeEidHub,date:this.extWarrantyDateChangeHub})
        .subscribe(response => {
          // console.log(response);
          this.firstComDateChangeLoading = false;
          this.extWarrantyDateChangeHub = undefined;
          this.extWarrantyDateChangeEidHub = "";
          this.firstComDateChangeTime = undefined;
          this.userDetails.showToast(3000,"Extended Warranty","Warranty Expiry Date is changed successfully");
        }, err => {
          console.log(err);
          this.firstComDateChangeLoading = false;
          this.userDetails.showToast(3000,"Extended Warranty","Failed to change Warranty Expiry Date");
        })
  }

  getNodeHealth(){
    if(this.healthEid == "" || this.healthEid == undefined){
      this.userDetails.showToast(3000,"eGlu Device Health","eID can not be empty");
      return;
    }
    this.healthEid = chunkSubstr(this.healthEid.replace(/:/g,"").replace(/-/g,"").toLowerCase(),2).join("-")
    let regex = new RegExp("[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}")
    if(!regex.test(this.healthEid)){
      this.userDetails.showToast(3000,"eGlu Device Health","eID is not valid")
      return
    }

    this.loadingHealthData = true;

    this.http.post(this.env.apiUrl + "/api/health/console/" + this.healthEid + "/TEST?showAllData="+this.showAllData,{
      startDate:this.graphStart,
      endDate:this.graphEnd
    })
        .subscribe(response => {
          // console.log(response);
          this.loadingHealthData = false;
          if(response["finalData"]) {
            this.handlehealthGraphResponse(response, this.healthEid)
          }else if(response["oldData"]) {
            this.handlehealthGraphResponseOld(response["oldData"],this.healthEid);
          }
        }, err => {
          console.log(err);
          this.loadingHealthData = false;
        })
  }


  handlehealthGraphResponse(res, nodeId) {
    var finalData = res.finalData;

    var voltage = [];
    var temp = [];
    var rssi = [];
    var parentIds = [];
    var vt = [];
    var tt = [];
    var rt = [];
    var prt = [];


    finalData.forEach((dataArr) => {
      if (dataArr[1].hasOwnProperty("voltage")) {
        voltage.push(dataArr[1].voltage);
        // this.name === 'IWS_SC_DC_1' ? voltage.push((dataArr[1].voltage+3)/2) : voltage.push(dataArr[1].voltage);
        vt.push(new Date(dataArr[0] * 1000));
      }
      if (dataArr[1].hasOwnProperty("temp")) {
        temp.push(dataArr[1].temp);
        tt.push(new Date(dataArr[0] * 1000));
      }
      if (dataArr[1].hasOwnProperty("rssi")) {
        let rssiStr = dataArr[1].rssi;
        rssi.push(rssiStr);
        rt.push(new Date(dataArr[0] * 1000));
      }
      if(dataArr[1].hasOwnProperty("parentId")) {
        parentIds.push(dataArr[1].parentId);
        prt.push(new Date(dataArr[0] * 1000))
      }
    })


    var traceVol = {
      x: vt,
      y: voltage,
      name: 'voltage',
    }

    var traceTemp = {
      x: tt,
      y: temp,
      yaxis: 'y2',
      name: 'temperature',
    }

    var traceRssi = {
      x: rt,
      y: rssi,
      yaxis: 'y3',
      name: 'rssi',
    }

    var traceRepeater = {
      x: prt,
      y: parentIds,
      yaxis: 'y4',
      name: 'parentId',
    }

    var selectorOptions = {
      buttons: [{
        step: 'day',
        stepmode: 'backward',
        count: 1,
        label: '1d'
      }, {
        step: 'day',
        stepmode: 'backward',
        count: 6,
        label: '1week'
      }, {
        step: 'month',
        stepmode: 'backward',
        count: 6,
        label: '6m'
      }, {
        step: 'year',
        stepmode: 'todate',
        count: 1,
        label: 'YTD'
      }, {
        step: 'year',
        stepmode: 'backward',
        count: 1,
        label: '1y'
      }, {
        step: 'all',
      }],
    };

    this.graph[nodeId] = {}

    this.graph[nodeId]['data'] = [traceVol, traceTemp, traceRssi, traceRepeater];

    this.graph[nodeId]['layout'] = {
      title: "health status ",
      xaxis: {
        width: 800,
        rangeselector: selectorOptions,
        rangeslider: {},
        layout: 'category'
      },
      yaxis: {
        height: 500,
        title: "voltage"
      },
      yaxis2: {
        title: "temperature",
        side: 'right',
        anchor: 'x',
        overlaying: 'y',
      },
      yaxis3: {
        title: "rssi",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
        position: 0.95
      },
      yaxis4: {
        title: "parentId",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
      }
    }
  }

  handlehealthGraphResponseOld(res, nodeId) {
    if(res.length == 0){
      return;
    }
    var finalDataVoltage = res.filter((item)=>{
      return item.name =="voltage"
    })[0];
    var finalDataRSSI = res.filter((item)=>{
      return item.name =="rssi"
    })[0];
    var finalDataTemp = res.filter((item)=>{
      return item.name =="temperature"
    })[0];

    var voltage = [];
    var temp = [];
    var rssi = [];
    var parentIds = [];
    var vt = [];
    var tt = [];
    var rt = [];
    var prt = [];

    if(finalDataVoltage.x) {
      for(const x of finalDataVoltage.x) {
        vt.push(new Date(x));
      }
    }
    if(finalDataVoltage.y) {
      for(const y of finalDataVoltage.y) {
        voltage.push(y+"");
      }
    }

    if(finalDataRSSI.x) {
      for(const x of finalDataRSSI.x) {
        rt.push(new Date(x));
      }
    }
    if(finalDataRSSI.y) {
      for(const y of finalDataRSSI.y) {
        rssi.push(y);
      }
    }

    if(finalDataTemp.x) {
      for(const x of finalDataTemp.x) {
        tt.push(new Date(x));
      }
    }
    if(finalDataTemp.y) {
      for(const y of finalDataTemp.y) {
        temp.push(y);
      }
    }

    // if(dataArr[1].hasOwnProperty("parentId")) {
    //   parentIds.push(dataArr[1].parentId);
    //   prt.push(new Date(dataArr[0] * 1000))
    // }


    var traceVol = {
      x: vt,
      y: voltage,
      name: 'voltage',
    }

    var traceTemp = {
      x: tt,
      y: temp,
      yaxis: 'y2',
      name: 'temperature',
    }

    var traceRssi = {
      x: rt,
      y: rssi,
      yaxis: 'y3',
      name: 'rssi',
    }

    var traceRepeater = {
      x: prt,
      y: parentIds,
      yaxis: 'y4',
      name: 'parentId',
    }

    var selectorOptions = {
      buttons: [{
        step: 'day',
        stepmode: 'backward',
        count: 1,
        label: '1d'
      }, {
        step: 'day',
        stepmode: 'backward',
        count: 6,
        label: '1week'
      }, {
        step: 'month',
        stepmode: 'backward',
        count: 6,
        label: '6m'
      }, {
        step: 'year',
        stepmode: 'todate',
        count: 1,
        label: 'YTD'
      }, {
        step: 'year',
        stepmode: 'backward',
        count: 1,
        label: '1y'
      }, {
        step: 'all',
      }],
    };

    this.graph[nodeId] = {}

    this.graph[nodeId]['data'] = [traceVol, traceTemp, traceRssi, traceRepeater];

    this.graph[nodeId]['layout'] = {
      title: "health status ",
      xaxis: {
        width: 800,
        rangeselector: selectorOptions,
        rangeslider: {},
        layout: 'category'
      },
      yaxis: {
        height: 500,
        title: "voltage"
      },
      yaxis2: {
        title: "temperature",
        side: 'right',
        anchor: 'x',
        overlaying: 'y',
      },
      yaxis3: {
        title: "rssi",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
        position: 0.95
      },
      yaxis4: {
        title: "parentId",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
      }
    }
  }

  replaceNode(){
    // if(this.reason == ""){
    //   this.userDetails.showToast(3000,"Node Replacement","Reason can not be empty")
    //   return
    // }

    this.dialogService.open(PasswordDialogComponent)
        .onClose.subscribe((password: string | null) => {
          if (password !== null) {
            this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
            .subscribe(response => {
              console.log(response)
              this.isReplacing = true;
              this.http.post(this.env.apiUrl + "/api/hubTransfer/replaceNode",{nodeIds:this.nodeIds})
                .subscribe(response => {
                  this.isReplacing = false;
                  console.log(response);
                  this.userDetails.showToast(2000, "Node Replaced Successfully", "Node replaced successfully");
                  setTimeout(() => {
                    this.router.navigate(['users']);
                  }, 2000);
                }, err => {
                  this.isReplacing = false;
                  console.log(err);
                })
            }, err => {
              console.log(err)
              // this.verifyUser()
              setTimeout(() => {
                this.userDetails.showToast(3000, err['message'], 'reloading page')
                location.reload()
              }, 3000);
            })
          } else {
            
          }
        });
  }

  keys(){
    return Object.keys(this.nodeIds);
  }

  getTodaysConsolePin(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/getTodaysConsolePin")
              .subscribe(response => {
                console.log(response);
                this.consolePinToday = response["pin"];
                this.consolePinLoading = false;
              }, err => {
                this.consolePinLoading = false;
              })
  }

  getImpPasswd(){
    if(this.impPasswdDialogOpen || this.impPasswdLoading || this.impPasswdLoaded) return;
    this.impPasswdDialogOpen = true;
    this.dialogService.open(PasswordDialogComponent, {
      context: {
        inputType: 'text',
        title: 'Customer Contact',
        description: 'Enter the email ID or phone number (with country code) of the customer you are trying to impersonate.',
        dialogWidth: '600px',
        placeholder: 'Email ID or phone number'
      }
    }).onClose.subscribe((contact: string | null) => {
      this.impPasswdDialogOpen = false;
      if(contact == null) return;
      const customerContact = contact.trim();
      if(!customerContact) {
        this.userDetails.showToast(3000, "Failure", "Customer Email ID/Phone No. is required");
        return;
      }
      this.impPasswdLoading = true;
      this.http.post(this.env.apiUrl + "/api/hubTransfer/getImpPasswd", {customerContact})
      .subscribe(response => {
        this.impPasswd = response["pwd"] || "";
        this.impPasswdLoading = false;
        this.impPasswdLoaded = response["success"] && !!this.impPasswd;
        if(!this.impPasswdLoaded) {
          this.userDetails.showToast(4000, "Failure", response["message"] || "Impersonation password is unavailable. Please try again.");
        }
      }, err => {
        this.impPasswdLoading = false;
        const fallbackMessages = {
          0: "Unable to reach the server. Please check your connection and try again.",
          400: "Please enter a valid customer email ID or phone number with country code.",
          401: "Your session has expired. Please sign in again.",
          403: "You do not have permission to view the impersonation password.",
          404: "No customer account was found for the provided email ID or phone number. Please check the details and include the country code for phone numbers."
        };
        const message = err.error && err.error.message ? err.error.message
          : fallbackMessages[err.status] || "Unable to verify the customer account. Please try again.";
        this.userDetails.showToast(4000, "Failure", message);
      });
    });
  }

  getImpPasswdInit(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/getImpPasswdInit")
              .subscribe(response => {
                console.log(response);
                this.impPasswdAllowed = response["allowed"];
              }, err => {
                this.impPasswdAllowed = false;
              })
  }

}
